// window.addEventListener("load", function () {
//   document.querySelectorAll("[data-truncate]").forEach(function (element) {
//     element.addEventListener("click", function (event) {
//       if (!event.target.matches("a, a *")) {
//         event.preventDefault();

//         var shortElement = document.querySelector(".truncate__short");
//         var longElement = document.querySelector(".truncate__long");

//         if (shortElement.classList.contains("active")) {
//           shortElement.classList.remove("active");
//           longElement.classList.add("active");
//         } else {
//           shortElement.classList.add("active");
//           longElement.classList.remove("active");
//         }
//       }
//     });
//   });
// });


$(function() {
  var Accordion = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;

    var links = this.el.find('.product-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
    $next = $this.next();
  
    $next.slideToggle();
    $this.parent().toggleClass('open');
  
    if (!e.data.multiple) {
      $el.find('.product-detail-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.product-detail-accordion-main'), false);
});

$('.slider-gallery-main').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arroes: true,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

jQuery(document).ready(function(jQuery){
  
  jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
    function e() {
      jQuery(".product-thumbnail .product-thumbnail__title").css("height", "auto");
      var e = -1;
      jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".product-thumbnail .product-thumbnail__title").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });

 $(".readmore_btn").click(function(){
    $(this).toggleClass("active-btn");
    $(".product_description_part_small").toggleClass("active");    
});

});

document.addEventListener("DOMContentLoaded", function() {
  const ticker = document.querySelector('.horizontal-ticker');
  const startDateStr = ticker.getAttribute('data-startdate'); 
  const endDateStr = ticker.getAttribute('data-enddate'); 

  // Convert the start and end dates to PST using toLocaleString
  const startDatePST = new Date(new Date(startDateStr.replace(' ', 'T') + '-08:00').toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  const endDatePST = new Date(new Date(endDateStr.replace(' ', 'T') + '-08:00').toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

  // Get the current time in local timezone
  const currentDateLocal = new Date();
  
  // Convert current time to PST
  const currentDatePST = new Date(currentDateLocal.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

  if (currentDatePST >= startDatePST && currentDatePST < endDatePST) {
    document.querySelector('.black-friday__banner').classList.remove('hide');
    document.querySelector('.skinacare__banner').classList.add('hide');
  } else {
    document.querySelector('.skinacare__banner').classList.remove('hide');
    document.querySelector('.black-friday__banner').classList.add('hide');
  }
});

/* Totality mobile sticky Add to Cart â€” 2026-08-12 */
(function () {
  'use strict';

  var MOBILE_MAX_WIDTH = 798;
  var SHOW_AFTER_SCROLL = 420;

  function initMobileStickyAddToCart() {
    if (document.getElementById('totality-mobile-sticky-atc')) return;

    var productForm = document.querySelector('.product_form[data-product-form] form[action*="/cart/add"]');
    if (!productForm) return;

    var mainButton = productForm.querySelector('[data-add-to-cart-trigger]');
    if (!mainButton) return;

    var productArea = productForm.closest('.product__information') || document;
    var titleNode = productArea.querySelector('h1') || document.querySelector('h1');
    var priceNode = productArea.querySelector('.current_price, .price .money, .product__price .money, .money');

    var bar = document.createElement('aside');
    bar.id = 'totality-mobile-sticky-atc';
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML =
      '<div class="totality-sticky-atc__details">' +
        '<span class="totality-sticky-atc__title"></span>' +
        '<span class="totality-sticky-atc__price"></span>' +
      '</div>' +
      '<button class="totality-sticky-atc__button" type="button">Add to cart</button>';
    document.body.appendChild(bar);

    var stickyTitle = bar.querySelector('.totality-sticky-atc__title');
    var stickyPrice = bar.querySelector('.totality-sticky-atc__price');
    var stickyButton = bar.querySelector('.totality-sticky-atc__button');
    var mainButtonInView = false;
    var clickCooldown = false;

    function isVisible(element) {
      if (!element) return false;
      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity || 1) > 0.05 &&
        rect.width > 0 && rect.height > 0;
    }

    function cartDrawerIsOpen() {
      var overlays = document.querySelectorAll('.ajax-cart__overlay');
      for (var i = 0; i < overlays.length; i += 1) {
        if (isVisible(overlays[i])) return true;
      }
      return false;
    }

    function updateContent() {
      stickyTitle.textContent = titleNode ? titleNode.textContent.trim() : 'Ready to order?';
      stickyPrice.textContent = priceNode ? priceNode.textContent.trim() : '';
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || clickCooldown;

      var sourceLabel = mainButton.getAttribute('data-label') || mainButton.textContent || 'Add to cart';
      stickyButton.textContent = sourceLabel.trim();
    }

    function updateVisibility() {
      var isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
      var shouldShow = window.innerWidth <= MOBILE_MAX_WIDTH &&
        window.scrollY >= SHOW_AFTER_SCROLL &&
        !mainButtonInView &&
        !cartDrawerIsOpen();
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      bar.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
      bar.style.setProperty('opacity', shouldShow ? '1' : '0', 'important');
      bar.style.setProperty('pointer-events', shouldShow ? 'auto' : 'none', 'important');
      bar.style.setProperty('transform', shouldShow ? 'translateY(0)' : 'translateY(110%)', 'important');
      updateContent();
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled || !isVisible(mainButton)) return;
      clickCooldown = true;
      bar.classList.remove('is-visible');
      updateContent();
      mainButton.click();
      window.setTimeout(function () {
        clickCooldown = false;
        updateVisibility();
      }, 1400);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        mainButtonInView = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0.15 });
      observer.observe(mainButton);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    productForm.addEventListener('change', function () {
      window.setTimeout(updateContent, 0);
    });
    document.addEventListener('ajaxCart:updated', updateVisibility);

    updateContent();
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileStickyAddToCart);
  } else {
    initMobileStickyAddToCart();
  }
}());
